module.exports = __webpack_public_path__ + "static/media/Louise_Fresco_tablet.9ce8acf0.jpg";